import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface DataTableColumn {
  key: string;
  label: string;
}

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
})
export class DataTableComponent {
  @Input() columns: DataTableColumn[] = [];
  @Input() rows: Array<Record<string, unknown>> = [];
  @Input() page = 1;
  @Input() totalPages = 1;

  /** Habilita cursor/hover e o evento rowClick. Off por padrão
   *  para não afetar as listagens que já usam o componente. */
  @Input() clickableRows = false;

  @Output() pageChange = new EventEmitter<number>();
  @Output() rowClick = new EventEmitter<Record<string, unknown>>();

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.page) {
      return;
    }
    this.pageChange.emit(page);
  }

  onRowClick(row: Record<string, unknown>): void {
    if (!this.clickableRows) {
      return;
    }
    this.rowClick.emit(row);
  }

  trackByIndex(index: number): number {
    return index;
  }
}